import { memo } from "react";

import type { AddressObject, InputMaybe } from "@/lib/gql/__generated__/graphql";

import { QuestionForMain } from "@/components/features/_layouts/island/main/question";
import { FeatureIslandCategoryQuestionForMain } from "@/components/features/_layouts/island/main-with-category/components/category-main-question";
import type { ForAutoGenerator } from "@/components/features/_model/types/auto-generator-for-view-model";

import { InputTextField } from "@/components/ui/form/fields/input-field/input-text";

type Props = {
	hasFeatureIslandCategoryContext?: boolean;

	required?: boolean;

	isEdited: boolean | undefined;
	hasError: boolean;

	address: ForAutoGenerator<InputMaybe<AddressObject> | undefined, "">;
	onSetPref: (e: string) => void;
	onSetCity: (e: string) => void;
	onSetTown: (e: string) => void;

	onSetPostalCode: (e: string) => Promise<void>;

	guide?: string;
	title?: string;
};

export const QuestionAddress = memo(
	({
		hasFeatureIslandCategoryContext = true,

		required = false,

		isEdited,
		hasError, //

		address,
		onSetCity,
		onSetPref,
		onSetTown,

		onSetPostalCode,

		guide,
		title,
	}: Props) => {
		return (
			<>
				{hasFeatureIslandCategoryContext ? (
					<FeatureIslandCategoryQuestionForMain
						required={required}
						title={title ?? "部屋ごとの住所"}
						guide={
							guide ??
							"コテージや棟別など、部屋ごとに住所を変えたい場合、部屋独自の所在地を登録しましょう。 <br />この部屋を予約したゲストにはメールでこちらの住所が送られます。"
						}
						isEdited={isEdited}
						hasError={hasError}
						inputChildren={
							<div className="flex flex-col gap-y-8">
								<div className="flex flex-col gap-y-4">
									<InputTextField
										label="郵便番号"
										value={address?.postalCode?.value}
										handleChange={onSetPostalCode}
										errorMessage={address?.postalCode?.error}
									/>
									<InputTextField
										label="都道府県"
										value={address?.pref?.value}
										handleChange={onSetPref}
										errorMessage={address?.pref?.error}
									/>
									<InputTextField
										label="市区町村"
										value={address?.city?.value}
										handleChange={onSetCity}
										errorMessage={address?.city?.error}
									/>
									<InputTextField
										label="市区町村以降"
										value={address?.town?.value}
										handleChange={onSetTown}
										errorMessage={address?.town?.error}
									/>
								</div>
							</div>
						}
					/>
				) : (
					<QuestionForMain
						required={required}
						title={title ?? "部屋ごとの住所"}
						guide={
							guide ??
							"コテージや棟別など、部屋ごとに住所を変えたい場合、部屋独自の所在地を登録しましょう。 <br />この部屋を予約したゲストにはメールでこちらの住所が送られます。"
						}
						inputChildren={
							<div className="flex flex-col gap-y-8">
								<div className="flex flex-col gap-y-4">
									<InputTextField
										label="郵便番号"
										value={address?.postalCode?.value}
										handleChange={onSetPostalCode}
										errorMessage={address?.postalCode?.error}
									/>
									<InputTextField
										label="都道府県"
										value={address?.pref?.value}
										handleChange={onSetPref}
										errorMessage={address?.pref?.error}
									/>
									<InputTextField
										label="市区町村"
										value={address?.city?.value}
										handleChange={onSetCity}
										errorMessage={address?.city?.error}
									/>
									<InputTextField
										label="市区町村以降"
										value={address?.town?.value}
										handleChange={onSetTown}
										errorMessage={address?.town?.error}
									/>
								</div>
							</div>
						}
					/>
				)}
			</>
		);
	},
);

QuestionAddress.displayName = "QuestionAddress";
